import { render, staticRenderFns } from "./PouchUpsert.vue?vue&type=template&id=80510336&scoped=true&"
import script from "./PouchUpsert.vue?vue&type=script&lang=js&"
export * from "./PouchUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80510336",
  null
  
)

export default component.exports